// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"styles_contentContainer__aCcdK","list":"styles_list__mgSwa","picture":"styles_picture__4t0T9"};